<template>
  <div class="row documento_dados tabledata">
    <div class="small-12 medium-12 large-10 columns">
      <div class="row">
        <a :href="item.link" class="small-12 medium-3 large-3 columns atitle">
          <!--<img class="pdf_icon" :src="AvisosIcon">-->
          <h3>{{ item.post_title }}</h3>
        </a>
        <a :href="item.link" class="small-12 medium-9 large-9 columns">
          <h3>{{ item.docaviso_descricao }}</h3>
        </a>
      </div>
    </div>
    <a :href="item.link" class="small-12 medium-12 large-2 columns show-for-large">
      <h3 class="datavigor">{{ item.docaviso_datavigor }}</h3>
    </a>
  </div>
</template>

<script>
import AvisosIcon from "@/assets/images/avisos_iconn.png";

export default {
  props:["item"],
  setup(){
    return {
      AvisosIcon
    }
  }
}
</script>

<style scoped>

.columns{
  padding-right: 0;
  padding-left: 0;
}

.columns a {
  font-size: 16px;
  font-family: "Montserrat Semibold";
  color: #707475;
  padding-top: 20px;
}

.columns{
  padding-top: 21px;
  padding-bottom: 21px;
}

.columns .columns {
  padding-right: 7px;
  padding-top: 7px;
  padding-bottom: 7px;
}

h3 {
  font-family: "Montserrat";
  font-size: 15px;
  margin-bottom: 0;
  color: #707475;
  padding-right: 20px;
}

a.atitle h3{
  padding-top: 0px;
  font-family: "Montserrat Bold";
  color: #707475 !important;
  font-size: 15px;
  display: inline;
}

.columns:last-of-type .columns:last-of-type {
  padding-right: 0!important;
}

.pdf_icon{
  width: 28px;
  margin-right: 20px;
}

.imagecolumn h3, .descolumn h3, h3.datavigor{
  padding-top: 7px;
}

.imagecolumn img{
  height: 55px;
}

@media (max-width: 1023px) {
  .anocolumn, .descolumn{
    display: none;
  }
}

@media (max-width: 767px) {
  .columns {
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .pdf_icon {
    width: 25px;
    margin-right: 15px;
  }
}
</style>